import React from "react";
import { Field, FieldProps, Form } from "formik";
import { Box, Card, Flex, Text } from "rebass";

import { FormTypes, fields, options } from "./formSettings";

import { FilesFieldComponent } from "./FilesFieldComponent";
import { FileList } from "./FileList";

import { Select } from "../components/Select";
import { SubmitButton } from "../components/SubmitButton";

import { Input } from "../../components/styled/Input";
import { Scrollbar } from "../../components/Scrollbar";
import { SpinnerSVG } from "../../components/svg/SpinnerSVG";
import { StyledTextarea } from "../../components/styled/Textarea";

const emailField = fields.find(({ name }) => name === "email");
const messageFiled = fields.find(({ name }) => name === "message");
const typeField = fields.find(({ name }) => name === "type");

export function FormComponent({ isSubmitting, isValid }: FormTypes) {
  return (
    <Form style={{ height: "100%" }}>
      <Flex
        height="100%"
        flexDirection="column"
      >
        <Card
          px="20px"
          py="9px"
          borderBottom="1px solid"
          borderBottomColor="sp-gray1"
          backgroundColor="#fff"
          css="display: flex; align-items: center;"
        >
          <Text
            mr="20px"
            color="zodiac"
            fontSize="16px"
            fontWeight={600}
          >
            {typeField.placeholder}
          </Text>

          <Box flex={1}>
            <Field
              name={typeField.name}
              component={Select}
              options={options}
            />
          </Box>
        </Card>

        <Card
          flex={1}
          mt="17px"
          px="20px"
          py="12px"
          borderRadius="5px"
          fontSize="18px"
          color="zodiac"
          backgroundColor="#fff"
          css="overflow: hidden; position: relative;"
        >
          <Scrollbar>
            <Field
              name={messageFiled.name}
              render={({ field }: FieldProps) => (
                <StyledTextarea
                  {...field}
                  placeholder={messageFiled.placeholder}
                  disabled={isSubmitting}
                  rows={4}
                />
              )}
            />
          </Scrollbar>
        </Card>

        <Box mt="12px">
          <Text
            as="p"
            mb="6px"
            color="#9b9eb5"
            fontSize="16px"
            fontWeight={600}
            lineHeight={1.19}
            letterSpacing="0.92px"
            css="text-transform: uppercase;"
          >
            add additional content
          </Text>

          <Field name="files" component={FilesFieldComponent} />

          <FileList />
        </Box>

        <Box mt="12px">
          <Text
            as="p"
            mb="6px"
            color="#9b9eb5"
            fontSize="16px"
            fontWeight={600}
            lineHeight={1.19}
            letterSpacing="0.92px"
            css="text-transform: uppercase;"
          >
            from
          </Text>

          <Field
            name={emailField.name}
            render={({ field }: FieldProps) => (
              <Input
                type={emailField.type}
                placeholder={emailField.placeholder}
                width={1}
                p="18px"
                fontSize="16px"
                fontWeight={600}
                lineHeight={1.19}
                css="& + & { margin-top: 1px; }"
                disabled={isSubmitting}
                {...field}
              />
            )}
          />
        </Box>

        <Flex
          mt="20px"
          fontSize="14px"
        >
          <SubmitButton
            width="unset"
            ml="auto"
            disabled={isSubmitting || !isValid}
          >
            <Flex alignItems="center">
              <span>send feedback</span>

              {
                isSubmitting && (
                  <>
                    &nbsp;

                    <SpinnerSVG fill="#fff" size={16} />
                  </>
                )
              }
            </Flex>
          </SubmitButton>
        </Flex>
      </Flex>
    </Form>
  );
}
